import {useEffect} from "react";
import useTenantAssets from "../common/useTenantLogo";

function TenantTitle() {
  const assets = useTenantAssets();

  useEffect(() => {
    if (assets?.title) {
      document.title = assets.title;
    }
      const link =
        document.getElementById("favicon") ||
        document.querySelector("link[rel~='icon']");

      if (link) {
        link.href = assets.getLogo('login');
      }
  }, [assets]);

  return null;
}

export default TenantTitle;